import React, { Fragment } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

const ProtectedRoute = ({ isAdmin, component: Component, ...rest }) => {

    const { isAuthenticated, loading, user } = useSelector(state => state.auth)

    return (
        <Fragment>
            {loading === false && (
                <Route
                    {...rest}
                    render={props => {
                        if (isAuthenticated === false) {
                            return <Redirect to='/login' />
                        }

                        // if (isAdmin === true && user.role !== 'admin') {
                        //     return <Redirect to="/" />
                        // }
                          // Check if `user` exists before accessing `user.role`
                          if (isAdmin === true && (!user || user.role !== 'admin')) {
                            return <Redirect to="/" />;
                        }

                        return <Component {...props} />
                    }}
                />
            )}
        </Fragment>
    )
}

export default ProtectedRoute